import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ComuneService } from 'src/app/services/comune.service';
import { AbstractCustomControlComponent } from '../abstract-custom-control/abstract-custom-control.component';
import { Observable } from 'rxjs';
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Provincia } from 'src/app/models/comune.model';
import { debounceTime, distinctUntilChanged, filter, map, skip, startWith, switchMap } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { Page } from 'src/app/models/page.model';

@Component({
  selector: 'app-provincia-autocomplete',
  templateUrl: './provincia-autocomplete.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProvinciaAutocompleteComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ProvinciaAutocompleteComponent),
      multi: true,
    },
  ],
})
export class ProvinciaAutocompleteComponent extends AbstractCustomControlComponent implements OnInit {
  @Input() value: string;
  @Output() provinciaSelected = new EventEmitter<Provincia>();
  @Output() isProvinciaFound = new EventEmitter<boolean>();
  @Output() hasProvinciaChanged = new EventEmitter<boolean>();

  province: Observable<Provincia[]>;
  selectedProvincia = new FormControl();

  constructor(private comuneService: ComuneService) {
    super();
  }

  ngOnInit() {
    this.province = this.selectedProvincia.valueChanges.pipe(
      this.value ? startWith(this.value) : startWith (''),
      skip(this.value ? 1 : 0),
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => typeof value === 'string'),
      switchMap(value => this.comuneService.getProvinceList(new HttpParams().set('descrProvincia', value))),
      map(res => res.content),
    );

    this.selectedProvincia.valueChanges.pipe(
      skip(1),
      filter(value => typeof value === 'string')
    ).subscribe(() => {
      this.writeValue(null);
      this.provinciaSelected.emit(null);
      this.hasProvinciaChanged.emit(true);
    });

    if (this.value) {
      this.selectedProvincia.patchValue(this.value);

      const provincia: Observable<Page<Provincia>> = this.comuneService.getProvinceList(new HttpParams().set('descrProvincia', this.value));
      provincia.subscribe(value => {
        if (!value.content.some(p => p.denominazione === this.value)) {
          this.isProvinciaFound.emit(false);
        } else {
          this.isProvinciaFound.emit(true);
        }
      });
    };
  }

  onSelectProvincia(selected: MatAutocompleteSelectedEvent) {
    const provincia: Provincia = selected.option.value;
    this.writeValue(provincia.denominazione);
    this.provinciaSelected.emit(provincia);
  }

  displayFn(value: Provincia | string): string {
    if (typeof value === 'string') {
      return value;
    };

    return value ? value.denominazione : '';
  }

  setDisabledState(disabled: boolean): void {
    super.setDisabledState(disabled);

    if (disabled) {
      this.selectedProvincia.disable();
    } else {
      this.selectedProvincia.enable();
    }
  }
}
